import PaymentConfiguration from './PaymentConfiguration';

export default PaymentConfiguration;
